import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BrandsServiceService } from "src/app/Services/brands-service.service";
import { EmbryoService } from "src/app/Services/Embryo.service";

@Component({
    selector: "app-brand-images",
    templateUrl: "./brand-images.component.html",
    styleUrls: ["./brand-images.component.scss"],
})
export class BrandImagesComponent {
    brand: any = {};
    brandId: any;
    lang: any;
    constructor(
        private brandsService: BrandsServiceService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        public embryoService: EmbryoService
    ) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
        this.activeRoute.params.subscribe((params) => {
            this.brandId = params.id;
            this.getBrandData(this.brandId);
        });
    }

    getBrandData(id: any) {
        this.brandsService.getBrand(id).subscribe((res: any) => {
            if (res.code == 200) {
                this.brand = res.data;
            }
        });
    }

    redirectBrand(brand: any, brandImage: any) {
        if (brandImage.type == 1) {
            this.router.navigate([`/${this.lang}/products`], {
                queryParams: { brand_id: brand.id, page: 1 },
            });
        } else {
            if (brandImage.link.includes(window.location.hostname))
                window.open(brandImage.link, "_self");
            else window.open(brandImage.link, "_blank");
        }
    }
}
